import { __assign } from "tslib";
import React, { forwardRef, useEffect, useCallback, useRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import { isWeekend, isValid } from 'date-fns';
import { DatePickerHeader } from './DatePickerHeader';
import { SCalendarStyleOverride } from './DatePicker.styled';
import { useForkRef } from '../../utils/hooks/useForkRef';
export var DatePickerCalendar = forwardRef(function DatePickerCalendar(props, externalRef) {
    var internalRef = useRef(null);
    var combinedRef = useForkRef(internalRef, externalRef);
    var date = props.date, onChange = props.onChange, disableWeekend = props.disableWeekend, maxDate = props.maxDate, minDate = props.minDate, shouldDisableDate = props.shouldDisableDate, inline = props.inline, locale = props.locale;
    var filterDateHandler = useCallback(function (dateToBeFiltered) {
        var isWeekendDisabled = disableWeekend && isWeekend(dateToBeFiltered);
        var isDateDisabled = shouldDisableDate === null || shouldDisableDate === void 0 ? void 0 : shouldDisableDate(dateToBeFiltered);
        return !(isWeekendDisabled || isDateDisabled);
    }, [disableWeekend, shouldDisableDate]);
    var DatePickerHeaderCustomRender = useCallback(function (datePickerHeaderProps) {
        return (React.createElement(DatePickerHeader, __assign({}, datePickerHeaderProps, { minDate: minDate, maxDate: maxDate, locale: locale })));
    }, [locale, minDate, maxDate]);
    useEffect(function () {
        var _a;
        // We are not using the complete solution of react-datepicker, but only the calendar.
        // When the calendar is shown, put focus on active day.
        // https://github.com/Hacker0x01/react-datepicker/blob/3194f8a0ec5cf71de5fd44f9def16910420c2b1c/src/index.jsx#L642
        if (!inline) {
            var selectedDay = (_a = internalRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.react-datepicker__day[tabindex="0"]');
            selectedDay && selectedDay.focus({ preventScroll: true });
        }
    }, []);
    return (React.createElement(SCalendarStyleOverride, { ref: combinedRef, tabIndex: -1, role: "application" },
        React.createElement(ReactDatePicker, { selected: isValid(date) ? date : null, onChange: onChange, maxDate: maxDate, minDate: minDate, filterDate: filterDateHandler, renderCustomHeader: DatePickerHeaderCustomRender, inline: true, fixedHeight: true, locale: locale })));
});
//# sourceMappingURL=DatePickerCalendar.js.map